import _get from "lodash/get";
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { typographyTheme } from '~typography';
import formTheme from '../styles/formTheme';
var Input = styled.input.withConfig({
  displayName: "Input",
  componentId: "ti594v-0"
})(["appearance:none;background-color:", ";border-color:", ";border-style:solid;border-top-left-radius:", ";border-top-right-radius:", ";border-width:0 0 1px;color:", ";display:block;font-family:", ";font-size:", ";height:", ";outline:0;padding:", " ", " ", ";transition:background 0.3s ease-in 0.1s;width:100%;", " ", " ", " ", " ", " ", ""], function (_ref) {
  var theme = _ref.theme,
      skin = _ref.skin;
  return _get(theme, "form.input." + skin + ".backgroundColor", formTheme.form.input[skin].backgroundColor);
}, function (_ref2) {
  var skin = _ref2.skin,
      theme = _ref2.theme;
  return _get(theme, "form.input." + skin + ".borderColor", formTheme.form.input[skin].borderColor);
}, function (_ref3) {
  var theme = _ref3.theme;
  return rem(_get(theme, 'form.input.borderRadius', formTheme.form.input.borderRadius));
}, function (_ref4) {
  var theme = _ref4.theme;
  return rem(_get(theme, 'form.input.borderRadius', formTheme.form.input.borderRadius));
}, function (_ref5) {
  var skin = _ref5.skin,
      theme = _ref5.theme;
  return _get(theme, "form.input." + skin + ".color", formTheme.form.input[skin].color);
}, function (_ref6) {
  var theme = _ref6.theme;
  return _get(theme, 'typography.base.fontFamily', typographyTheme.typography.base.fontFamily);
}, function (_ref7) {
  var theme = _ref7.theme;
  return rem(_get(theme, 'form.input.fontSize', formTheme.form.input.fontSize));
}, function (_ref8) {
  var theme = _ref8.theme;
  return rem(_get(theme, 'form.input.height', formTheme.form.input.height));
}, rem(24), rem(12), rem(6), function (_ref9) {
  var readOnly = _ref9.readOnly,
      skin = _ref9.skin,
      theme = _ref9.theme;
  return !readOnly && css(["&:focus{background-color:", ";}"], _get(theme, "form.input." + skin + ".backgroundColorFocus", formTheme.form.input[skin].backgroundColorFocus));
}, function (_ref10) {
  var readOnly = _ref10.readOnly;
  return readOnly && css(["border-color:transparent;"]);
}, function (_ref11) {
  var theme = _ref11.theme,
      skin = _ref11.skin,
      disabled = _ref11.disabled;
  return disabled && css(["border-color:", ";border-style:dotted;color:", ";cursor:not-allowed;"], _get(theme, "form.input." + skin + ".colorDisabled", formTheme.form.input[skin].colorDisabled), _get(theme, "form.input." + skin + ".colorDisabled", formTheme.form.input[skin].colorDisabled));
}, function (_ref12) {
  var prependAddon = _ref12.prependAddon;
  return prependAddon && css(["padding-left:", ";"], rem(32));
}, function (_ref13) {
  var appendAddon = _ref13.appendAddon;
  return appendAddon && css(["padding-right:", ";"], rem(32));
}, function (_ref14) {
  var hideLabel = _ref14.hideLabel,
      theme = _ref14.theme;
  return hideLabel && css(["height:", ";padding-top:", ";"], rem(_get(theme, 'form.input.heightNoLabel', formTheme.form.input.heightNoLabel)), rem(12));
});
export default Input;